import { useState, useEffect } from "react";
import { Form, Button } from "semantic-ui-react";
import { toast } from "../..";
import { UserData } from "../../actions/authentificationActions";
import { addUser, getTsos } from "../../services/userService";

interface IProps {
    handleConcatUser: (user: UserData) => void;
    localLoginEnabled: boolean;
}

export interface ITso {
    key: string;
    text: string;
    value: string;
}

export const CreateUserForm = ({ handleConcatUser, localLoginEnabled }: IProps) => {
    const [userDto, setUserDto] = useState({
        username: "",
        password: "",
        firstName: "",
        lastName: "",
        role: "",
        tso: "",
    });
    const [tsos, setTsos] = useState<ITso[]>([]);
    const isEnabled =
        userDto.username.length > 0 &&
        userDto.firstName.length > 0 &&
        userDto.lastName.length > 0 &&
        userDto.role.length > 0 &&
        (userDto.role === "TSO" ? userDto.tso.length > 0 : true);

    useEffect(() => {
        getTsos().then(res => {
            const sortedTsos = [...res];
            sortedTsos.sort((a, b) => a.text.localeCompare(b.text));
            setTsos(sortedTsos);
        });
        if (userDto.role === "User" || userDto.role === "Admin" || userDto.role === "SuperAdmin")
            userDto.tso = "";
    }, [userDto]);

    const handleCreateUser = async () => {
        const res = await addUser(userDto);
        if (res.ok) {
            handleConcatUser((await res.json()) as UserData);
            const form: HTMLFormElement | null = document.querySelector("#add-user-form");
            form!.reset();
            toast("User successfully created", true);
        } else {
            try {
                const err = await res.json();
                toast(err.message, false);
            } catch (err) {
                toast("Unable to create user", false);
            }
        }
    };

    return (
        <Form id="add-user-form">
            <div id="div-add-user-form" className="add-user-form">
                <Form.Field id="formField-CreateUser-a">
                    <label id="username-createUser">Username</label>
                    <input
                        id="username"
                        type="email"
                        placeholder="Username"
                        onChange={e =>
                            setUserDto({
                                ...userDto,
                                username: e.target.value,
                            })
                        }
                    />
                </Form.Field>
                {localLoginEnabled && (
                    <Form.Field id="formField-CreateUser-b">
                        <label id="password-createUser">Password</label>
                        <input
                            id="password-input-b"
                            type="password"
                            placeholder="Password"
                            onChange={e =>
                                setUserDto({
                                    ...userDto,
                                    password: e.target.value,
                                })
                            }
                        />
                    </Form.Field>
                )}
                <Form.Field id="formField-CreateUser-c">
                    <label id="firstName-createUser">First name</label>
                    <input
                        id="firstName-input-c"
                        type="text"
                        placeholder="First name"
                        onChange={e =>
                            setUserDto({
                                ...userDto,
                                firstName: e.target.value,
                            })
                        }
                    />
                </Form.Field>
                <Form.Field id="formField-CreateUser-d">
                    <label id="lastName-createUser">Last name</label>
                    <input
                        id="lastName-input-d"
                        type="text"
                        placeholder="Last name"
                        onChange={e =>
                            setUserDto({
                                ...userDto,
                                lastName: e.target.value,
                            })
                        }
                    />
                </Form.Field>
                <Form.Select
                    selectOnBlur={false}
                    id="userTypeSelect"
                    className="add-user-dropdown"
                    label="Type of user"
                    options={[
                        { key: "user", text: "User", value: "User" },
                        { key: "tso", text: "TSO", value: "TSO" },
                        {
                            key: "tsoadmin",
                            text: "TSO Admin",
                            value: "TSOAdmin",
                        },
                        { key: "admin", text: "Admin", value: "Admin" },
                    ]}
                    placeholder="Type of user"
                    onChange={(e, { value }) =>
                        setUserDto({
                            ...userDto,
                            role: value!.toString(),
                        })
                    }
                />
                {userDto.role === "TSO" || userDto.role === "TSOAdmin" ? (
                    <Form.Select
                        search
                        selectOnBlur={false}
                        id="tsoSelect"
                        className="add-user-dropdown"
                        label="TSO"
                        options={tsos}
                        placeholder="Select TSO"
                        onChange={(e, { value }) =>
                            setUserDto({
                                ...userDto,
                                tso: value!.toString(),
                            })
                        }
                    />
                ) : null}
            </div>
            <div id="submit-button-container">
                <Button
                    id="submit-button-createUser"
                    type="submit"
                    onClick={handleCreateUser}
                    content="Save"
                    primary
                    disabled={!isEnabled}
                />
            </div>
        </Form>
    );
};
